import React from "react";

const Explore = () => {
  return <div id="explore">Explore page</div>;
};

export default Explore;
